<div class="main-container">
  <div [style]=" 'right:' + positionRight  + ';left:' + positionLeft +  ';bottom:' + positionBottom" class="text-container">
    <div class="title">
      {{title}}
    </div>
    <div class="text">
      <div>{{text}}</div>
    </div>
  </div>
</div>